export default "__VITE_ASSET__CBlxL_hO__"